import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

const decodeExp = (t) => {
  try { const p = JSON.parse(atob(t.split(".")[1])); return p.exp ? p.exp * 1000 : 0; }
  catch { return 0; }
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deadline, setDeadline] = useState(0); // epoch ms when the session token expires

  const loadMe = async () => {
    const t = localStorage.getItem("oa_token");
    if (!t) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setDeadline(decodeExp(t));
    } catch {
      localStorage.removeItem("oa_token");
    }
    setLoading(false);
  };

  useEffect(() => { loadMe(); }, []);

  const completeLogin = (token, u, expiresIn) => {
    localStorage.setItem("oa_token", token);
    setUser(u);
    setDeadline(expiresIn ? Date.now() + expiresIn * 1000 : decodeExp(token));
  };

  // Slides the session for active users. Returns true on success.
  const refresh = async () => {
    try {
      const { data } = await api.post("/auth/refresh");
      localStorage.setItem("oa_token", data.access_token);
      setUser(data.user);
      setDeadline(data.expiresIn ? Date.now() + data.expiresIn * 1000 : decodeExp(data.access_token));
      return true;
    } catch {
      logout(true);
      return false;
    }
  };

  const logout = async (expired = false) => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("oa_token");
    setUser(null);
    if (expired) sessionStorage.setItem("oa_session_expired", "1");
    window.location.href = "/login";
  };

  const can = (perm) => !!user && (user.role === "admin" || (user.permissions || []).includes(perm));

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, deadline, completeLogin, refresh, logout, can }}>
      {children}
    </AuthCtx.Provider>
  );
}
